<template>
  <router-link
    v-ripple
    :to="route"
    :target="newTab ? '_blank' : ''"
    class="q-py-md text-body-1 cursor-pointer route text-white-1"
    active-class="active"
  >
    <span class="q-ml-lg">{{ label }}</span>
  </router-link>
</template>

<script>
export default {
  props: {
    label: String,
    route: [String, Object],
    newTab: Boolean
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/fonts.scss';

.route.active {
  @extend .text-heading-3;
  z-index: 1;
}
</style>
